export default __webpack_public_path__ + "static/media/instagram.8481a6ae.svg";